import React from "react";
import "./Preloader.css";

export const Preloader = () => {
  return (
    <div className="container">
      <div className="item-1"></div>
      <div className="item-2"></div>
      <div className="item-3"></div>
      <div className="item-4"></div>
      <div className="item-5"></div>
    </div>
  );
};
